import { render, staticRenderFns } from "./ad-budget.vue?vue&type=template&id=5f55e961&scoped=true"
import script from "./ad-budget.vue?vue&type=script&setup=true&lang=js"
export * from "./ad-budget.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55e961",
  null
  
)

export default component.exports